<div class="svg-icon" *ngIf="src" [ngStyle]="{'width':size,'height':size}" [innerHtml]="svgDatas"></div>
<span *ngIf="!src">miss src</span>
